import { ProductList } from "./ProductList";
import { ProductEdit } from "./ProductEdit";
import { ProductShow } from "./ProductShow";
import type { Product } from "./types";

export default {
  list: ProductList,
  edit: ProductEdit,
  show: ProductShow,
  recordRepresentation: (record: Product) => record.producto ?? record.codigo ?? "",
};
